<template>
  <header class="navbar" :class="{ scrolled: isScrolled }">
    <div class="container nav-container">
      <a href="#home" class="logo" @click.prevent="scrollTo('home')">
        <IconSvg name="shield" class="logo-icon" />
        <span class="logo-text">{{ t('hero.title') }}</span>
      </a>
      <nav class="nav-links" :class="{ open: menuOpen }">
        <a href="#home" @click.prevent="navTo('home')">{{ t('nav.home') }}</a>
        <a href="#features" @click.prevent="navTo('features')">{{ t('nav.features') }}</a>
        <a href="#modes" @click.prevent="navTo('modes')">{{ t('nav.modes') }}</a>
        <a href="#weapons" @click.prevent="navTo('weapons')">{{ t('nav.weapons') }}</a>
        <a href="#download" class="nav-cta" @click.prevent="navTo('download')">{{ t('nav.download') }}</a>
      </nav>
      <button class="menu-toggle" @click="menuOpen = !menuOpen" aria-label="Menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div class="nav-actions">
        <select v-model="locale" class="lang-select" aria-label="Language">
          <option value="zh">中文</option>
          <option value="en">English</option>
        </select>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import IconSvg from './IconSvg.vue'

const { t, locale } = useI18n()

const isScrolled = ref(false)
const menuOpen = ref(false)

const onScroll = () => {
  isScrolled.value = window.scrollY > 40
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})

const scrollTo = (id) => {
  const el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' })
  }
}

const navTo = (id) => {
  scrollTo(id)
  menuOpen.value = false
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 1rem 0;
  transition: background 0.3s ease, box-shadow 0.3s ease, padding 0.3s ease;
}
.navbar.scrolled {
  background: rgba(20, 5, 5, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 20px rgba(0,0,0,0.25);
  padding: 0.75rem 0;
}
.nav-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}
.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #fff;
  text-decoration: none;
  font-weight: 800;
  font-size: 1.25rem;
}
.logo-icon {
  width: 28px;
  height: 28px;
  color: #60a5fa;
}
.nav-links {
  display: flex;
  gap: 2rem;
  align-items: center;
}
.nav-links a {
  color: rgba(255,255,255,0.85);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: color 0.2s;
}
.nav-links a:hover {
  color: #fff;
}
.nav-cta {
  background: var(--accent);
  color: #fff !important;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  font-weight: 600;
}
.lang-select {
  background: rgba(255,255,255,0.12);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 8px;
  padding: 0.4rem 0.6rem;
  font-size: 0.9rem;
  cursor: pointer;
  outline: none;
}
.lang-select option {
  background: #2a0a0a;
  color: #fff;
}
.menu-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
}
.menu-toggle span {
  display: block;
  width: 24px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
  transition: all 0.3s;
}
@media (max-width: 768px) {
  .menu-toggle {
    display: flex;
  }
  .nav-links {
    display: none;
    position: absolute;
    top: calc(100% + 0.75rem);
    left: 1.5rem;
    right: 1.5rem;
    flex-direction: column;
    gap: 1rem;
    background: rgba(20, 5, 5, 0.96);
    backdrop-filter: blur(12px);
    padding: 1.25rem;
    border-radius: 16px;
    box-shadow: 0 16px 40px rgba(0,0,0,0.3);
  }
  .nav-links.open {
    display: flex;
  }
  .nav-links a {
    width: 100%;
    text-align: center;
  }
  .nav-cta {
    text-align: center;
  }
}
</style>
